<template>
  <div>
    <div v-if="personCurrent.id > 0">
      <Stat/>
    </div>
    <div v-else-if="!personIsAuth" class="greeting container">
      <div class="col-m-12 greeting--txt">
        <p>«Вкусомер»&nbsp;— это инструмент, позволяющий каждому проверить свой дизайнерский вкус. С&nbsp;его помощью профессиональные дизайнеры оттачивают свое мастерство, работодатели проверяют исполнителей, а&nbsp;любители выявляют свои сильные и&nbsp;слабые стороны.</p>
        <div class="greeting--auth">
          <p>Вход</p>
          <!--
		  <a href="/accounts/login/facebook/?next=/" class="greeting--auth-button greeting--auth-button--fb">
            <svg viewBox="0 0 200 200">
              <circle fill="#315091" cx="100" cy="100" r="100"/>
            </svg>
            <img src="/static/social-fb.svg">
          </a>
          <a href="/accounts/login/google-oauth2/?next=/" class="greeting--auth-button greeting--auth-button--gl">
            <svg viewBox="0 0 200 200">
              <circle fill="#d13325" cx="100" cy="100" r="100"/>
            </svg>
            <img src="/static/social-gl.svg">
          </a>
		  -->
          <a href="/accounts/login/vk-oauth2/?redirect_uri=/&next=/" class="greeting--auth-button greeting--auth-button--vk">
            <svg viewBox="0 0 200 200">
              <circle fill="#0077FF" cx="100" cy="100" r="100"/>
            </svg>
            <img src="/static/social-vk.svg">
          </a>
        </div>

        <p class="greeting__terms">Авторизуясь, я&#160;даю согласие<br/>
          на&#160;обработку моих <a href="/static/terms.pdf">персональных данных</a>.</p>
      </div>
      <Footy :theme="'dark'"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Footy from '@/layouts/Footer';
import Stat from '@/layouts/Stat';

export default {
  name: 'Greeting',
  components: {
    Footy,
    Stat,
  },
  computed: mapGetters({
    personCurrent: 'personCurrent',
    personIsAuth: 'personIsAuth',
    person: 'person',
  }),
  mounted() {
    const firstVisit = this.$cookie.get('first-visit');
    if (!this.$route.params.tag) {
      if (!firstVisit) {
        this.showPersonPage();
      } else {
        this.$store.commit('SET_CATEGORY', 'all');
      }
    }
  },

  methods: {
    showPersonPage() {
      const waitUser = setInterval(() => {
        if (this.personCurrent.id) {
          clearInterval(waitUser);
          this.$cookie.set('first-visit', 'true', 999999);
          this.$router.push(`/accounts/${this.personCurrent.id}/`);
        }
      }, 100);
    },
  },
};
</script>
<style>
@keyframes show{
  from,20%{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
}

.greeting{
  animation: show .5s ease-in-out;
  text-align: center;
  padding: 10px 50px;

  @media (max-width: $mediaIpad){
    padding: 10px 20px;
    text-align: left;
  }

  &--txt{
    display: inline-block;
    line-height: 1.85;
    max-width: 700px;
    font-size: 120%;
    margin: 0 auto;
    float: none;

    @media (max-width: $mediaIpad){
      font-size: 100%;
    }
  }

  &--auth{
    margin-bottom: 50px;
    margin-top: 50px;
    min-width: 300px;

    @media (max-width: 600px){
      margin-top: 40px;
    }

    &-button{
      display: inline-block;
      vertical-align: top;
      margin-right: -5px;
      position: relative;
      text-align: center;
      overflow: hidden;
      cursor: pointer;
      padding: 42px 0;
      height: 130px;
      width: 130px;
      outline: 0;
      border: 0;

      &:hover{
        svg{
          transform: scale(1.5);
          opacity: 1;
        }

        img{
          transform: scale(1.2);
        }
      }

      &--fb {
        background: #3b5998;
      }

      &--gl {
        background: #db4437;
      }

      &--vk {
        background: #0077FF;
      }

      svg{
        transition: all .6s ease-in-out;
        transform: scale(.1);
        position: absolute;
        height: auto;
        width: 100%;
        opacity: 0;
        left: 0;
        top: 0;
      }

      img{
        transition: transform .3s ease-in-out;
        position: relative;
        z-index: 99;
        height: 46px;
        width: 55px;
      }

      @media (max-width: 600px) {
        padding: 15px 0;
        height: 60px;
        width: 60px;

        img {
          height: 25px;
          width: 25px;
        }
      }
    }
  }

  &__terms {
    color: #999;
    font-size: 80%;
    line-height: 1.4;

    a {
      border-color: rgba(153,153,153,0.3);
      color: inherit;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Greeting.vue?db487e32